import React from "react"
import tw from "twin.macro"
import CircleCheck from "../images/circle-check.svg"
import { H3, P } from "../components/page-elements"

const Container = tw.div`
    flex
    flex-row
    my-4
`

interface FeatureItemProps {
  title: string
  body: string
}

export const FeatureItem: React.FC<FeatureItemProps> = ({ title, body }) => {
  return (
    <Container>
      <div className="w-10">
        <img src={CircleCheck} alt="Circled checkmark" />
      </div>
      <div className="w-full">
        <H3 className="text-header mt-0" style={{ marginTop: 0 }}>
          {title}
        </H3>
        <P className="text-body" style={{ marginTop: 0 }}>
          {body}
        </P>
      </div>
    </Container>
  )
}
